import Link from "next/link";
import Image from "next/image";
import ItemFooter from "./ItemFooter";
import ItemHeader from "./ItemHeader";
import { textFormat, getDomainFromUrl } from "../../tools/helper";
import { useEffect, useState, memo } from "react";
import userStore from "../../store/userStore";
import useWindowSize from "../../hooks/useWindowSize";
import { MdOutlinePlayCircle } from "react-icons/md";
import { useRouter } from "@bprogress/next";
import { FaEye } from "react-icons/fa";
// import { useRouter } from "next/navigation";

function ItemSmall(props) {
  const router = useRouter();
  const windowSize = useWindowSize();

  const userNsfw = userStore((state) => state.userNsfw);

  const [showNsfw, setShowNsfw] = useState(false);
  const [boxTitre, setBoxTitre] = useState(props.box.titre);

  useEffect(() => {
    setBoxTitre(
      textFormat({
        html: true,
        hidebbcode: true,
        text: props.box.titre,
      })
    );
  }, [props.box.titre]);

  useEffect(() => {
    setShowNsfw(userNsfw);
  }, [userNsfw]);

  const goToBox = () => {
    router.push("/" + props.box.permalink);
  };

  let youtubeThumbUrl = false;
  if (props.box.id_youtube) {
    youtubeThumbUrl = `https://i.ytimg.com/vi/${props.box.id_youtube}/${
      props.box.is_youtube_maxres && props.box.is_youtube_maxres == 1
        ? "maxresdefault"
        : "hqdefault"
    }.jpg`;
  }

  return (
    <>
      <div
        // onClick={() => router.push(`/box/${props.box.permalink}`)}
        onClick={(event) => {
          // Check if the Ctrl, Cmd (metaKey), or middle button (button 1) is pressed
          if (event.ctrlKey || event.metaKey || event.button === 1) {
            window.open(`/${props.box.permalink}`, "_blank");
          } else {
            router.push(`/${props.box.permalink}`);
          }
        }}
        className="block mb-0.5 sm:mb-0 cursor-pointer bg-base-100 hover:bg-base-200/75"
        style={{ outline: "none" }}
      >
        <div className="text-base-content">
          <div className="p-2 sm:p-0 sm:py-0">
            {windowSize.width < 640 && <ItemHeader box={props.box} />}
            <div className={`flex flex-row-reverse sm:flex-row`}>
              {props.box.type == "image" ||
              props.box.type == "video" ||
              props.box.type == "mp4" ||
              props.box.type == "lien" ||
              (props.box.type == "texte" && windowSize.width >= 640) ||
              props.box.type == "gif" ? (
                <div
                  className={`flex-none w-1/3 sm:w-40 pl-2 sm:pl-0 sm:pr-2 pt-1 sm:pt-0`}
                >
                  <div className="relative block outline-0 w-full">
                    <Link
                      href={`/${props.box.permalink}`}
                      onClick={(e) => e.preventDefault()}
                    >
                      {props.box.nsfw == 1 && !showNsfw ? (
                        <div
                          className={`absolute z-1 top-0 left-0 right-0 bottom-0 w-full h-full flex items-center justify-center bg-base-100/80 backdrop-blur-md rounded-lg`}
                        >
                          <div className="text-base-content/80 font-semibold">
                            NSFW
                          </div>
                        </div>
                      ) : null}

                      {props.box.titre.match(/\[spoiler\]/i) && (
                        <div className="absolute z-1 top-0 left-0 right-0 bottom-0 w-full h-full flex items-center justify-center bg-base-100/80 backdrop-blur-md rounded-lg">
                          <div className="text-base-content/80 font-semibold">
                            SPOILER
                          </div>
                        </div>
                      )}

                      {props.box.type == "texte" && (
                        <div className="absolute z-1 w-full h-full flex items-center justify-center bg-base-200 text-base rounded-lg">
                          <div className="text-base-content/80 font-semibold">
                            <svg
                              style={{ width: "24px", height: "24px" }}
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M3,3H16V6H11V18H8V6H3V3M12,7H14V9H12V7M15,7H17V9H15V7M18,7H20V9H18V7M12,10H14V12H12V10M12,13H14V15H12V13M12,16H14V18H12V16M12,19H14V21H12V19Z"
                              />
                            </svg>
                          </div>
                        </div>
                      )}

                      {props.box.type == "video" || props.box.type == "mp4" ? (
                        <div className="absolute h-full w-full flex justify-center items-center text-white">
                          <MdOutlinePlayCircle className="w-6 h-6" />
                        </div>
                      ) : null}
                      <img
                        loading="lazy"
                        src={
                          props.box.id_youtube
                            ? youtubeThumbUrl
                            : props.box.miniature_uniforme
                        }
                        // src={
                        //   props.box.image && props.box.type == "image"
                        //     ? "https://static.choualbox.com/mini.php?q=100&zc=1&w=550&h=300&src=" +
                        //       props.box.image
                        //     : props.box.miniature_uniforme
                        // }
                        alt={boxTitre}
                        width="400"
                        height="300"
                        className="block w-full aspect-video object-cover rounded-lg"
                        // quality={100}
                      />
                    </Link>
                  </div>
                </div>
              ) : null}
              <div className={`flex-auto super-break-words w-2/3 sm:w-9/12`}>
                {windowSize.width >= 640 && (
                  <ItemHeader box={props.box} className="mb-0" />
                )}

                <h3>
                  <Link
                    href={`/${props.box.permalink}`}
                    onClick={(e) => e.preventDefault()}
                    className="dejavu text-lg leading-6 mb-2 text-base-content"
                  >
                    {props.box.nsfw == 1 && (
                      <span className="text-sm text-pink-500 mr-1">[NSFW]</span>
                    )}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: boxTitre,
                      }}
                    ></span>
                  </Link>
                  {props.box.type == "lien" || props.box.type == "video" ? (
                    <Link
                      href={`/${props.box.permalink}`}
                      onClick={(e) => e.preventDefault()}
                      className="flex items-center text-xs opacity-70"
                    >
                      {/* <LinkIcon className="w-3 h-3 mr-1" /> */}
                      {/* retiré car politique third party cookie, aussi ça déconne  */}
                      {/* <img
                        src={
                          "https://www.google.com/s2/favicons?domain=" +
                          getDomainFromUrl(props.box.media_url)
                        }
                        className="w-3 h-3 mr-1"
                      /> */}
                      {getDomainFromUrl(props.box.media_url)}
                    </Link>
                  ) : null}
                </h3>
                {windowSize.width >= 640 && (
                  <ItemFooter
                    userTk={props.userTk ? props.userTk : false}
                    item={props.box}
                    module="boxs"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {windowSize.width < 640 && (
          <ItemFooter
            userTk={props.userTk ? props.userTk : false}
            item={props.box}
            module="boxs"
          />
        )}
      </div>
      <div className="border border-b border-base-content/10 my-1"></div>
    </>
  );
}

export default memo(ItemSmall);
